var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-info"},[_c('div',{staticClass:"pages"},[_vm._v("\n        Página "+_vm._s(_vm.value.current_page)+" de "+_vm._s(_vm.value.last_page)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"total"},[_vm._v("\n        Exibindo "+_vm._s(_vm.value.data.length)+" de "+_vm._s(_vm.value.total)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f83224d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Pagination/PaginationInfo.vue
// module id = null
// module chunks = 